import { TemplateRef } from '@angular/core';

export interface Datatable {
  page: number;
  total: number;
  total_page: number;
  limit: number;
  data: any;
}

export interface DatatableParamsChange {
  page: number;
  limit: number;
  sort?: string;
  direction?: DatatableSortDirection;
}

export type DatatableSortDirection = 'asc' | 'desc';

export type DatatableSortFieldMap = Record<string, string>;

export interface DatatableSortParams {
  sort: string | null;
  direction: DatatableSortDirection | null;
}

export interface DatatableSort {
  prop?: string;
  dir?: string;
}

export interface DatatableSortChangeEvent {
  sort?: {
    sorts?: DatatableSort[];
  };
}

function isDatatableSortDirection(value: string | undefined): value is DatatableSortDirection {
  return value === 'asc' || value === 'desc';
}

export function createDatatableSortParams(
  event: DatatableSortChangeEvent,
  fieldMap: DatatableSortFieldMap = {}
): DatatableSortParams {
  const sort = event.sort?.sorts?.[0];
  const prop = sort?.prop;
  const direction = sort?.dir;

  if (prop == null || !isDatatableSortDirection(direction)) {
    return {
      sort: null,
      direction: null,
    };
  }

  const field = fieldMap[prop] ?? prop;

  return {
    sort: field,
    direction,
  };
}

export function createDatatableOrder(
  event: DatatableSortChangeEvent,
  fieldMap: DatatableSortFieldMap = {}
): string | null {
  const sortParams = createDatatableSortParams(event, fieldMap);

  if (sortParams.sort == null || sortParams.direction == null) {
    return null;
  }

  return `${sortParams.sort} ${sortParams.direction}`;
}

export interface DatatabelColumn {
  id: string;
  title: string;
  sortDisabled?: boolean;
  mask?: string;
  label?: string; // default use same with id
  cellTemplate?: TemplateRef<any>;
  headTemplate?: TemplateRef<any>;
  columnClass?: string;
  headClass?: string;
}

export interface BlogCategoryDatatabelColumn {
  id: string;
  name: string;
  description: string;
  sortDisabled?: boolean;
  mask?: string;
  label?: string; // default use same with id
  cellTemplate?: TemplateRef<any>;
  headTemplate?: TemplateRef<any>;
  columnClass?: string;
  headClass?: string;
}
export interface Bloglist{
  id:string;
  title:string;
  article:string;
  blog_category_id:string;
 tutor_id:string;
 sortDisabled?: boolean;
 cellTemplate?: TemplateRef<any>;
 headTemplate?: TemplateRef<any>;
}
